import { render } from "./FileViewFull.vue?vue&type=template&id=0709192d&scoped=true"
import script from "./FileViewFull.vue?vue&type=script&lang=js"
export * from "./FileViewFull.vue?vue&type=script&lang=js"

import "./FileViewFull.vue?vue&type=style&index=0&id=0709192d&lang=scss&scoped=true"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0709192d"]])

export default __exports__